import { render, staticRenderFns } from "./AddTagsAction.vue?vue&type=template&id=1bbce12c"
import script from "./AddTagsAction.vue?vue&type=script&lang=js"
export * from "./AddTagsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports